/**
 * Layout spacing tokens from the Foundation Figma library. Each value is a multiplier of the 4px
 * spacing unit, so it can be passed straight to any spacing system prop. Tokens that change per
 * breakpoint are responsive values and resize on their own.
 *
 * Name the relationship, not the size: `space.gap.related` says why two things are 16px apart, and
 * changing the token moves every place that uses it.
 *
 * @example
 * <Stack gap={space.gap.related}>
 * <Box p={space.inset.lg}>
 */
export const space = {
    /** Padding inside a container. */
    inset: {
        none: 0,
        xs: 1,
        sm: 2,
        md: 3,
        lg: 4,
        xl: 6,
    },
    /** Space between siblings, from the closest relationship to the furthest. */
    gap: {
        attached: 0.5,
        tight: 1,
        items: 2,
        related: 4,
        groups: 6,
        sections: { base: 8, tabletPortrait: 10, laptop: 12 },
        page: { base: 14, tabletPortrait: 16, laptop: 20, xl: 24 },
    },
    grid: {
        margin: { base: 6, tabletPortrait: 10, xl: 16 },
        gutter: 4,
    },
};
